import React from "react";

import {DropdownMenuItem, Text} from "@reside/ui";
import {connect} from "react-redux";
import {Dictionary} from "lodash";

import {select} from "../../../../store";
import {AdmissionFromSearch} from "../../../../services/AdmissionsService";
import {getResidentTestId, isDeleteRestrictedForUser} from "../../helper";
import {ModalName, useDashboardModalContext} from "../../DashboardModalContext";
import {AdmissionCardActionsMenu} from "./AdmissionCardActionsMenu";

type StateProps = Readonly<{
  isResideAdmin: boolean;
  isOrgAdmin: boolean;
  isFacilityAdmin: boolean;
  facilityFlagsById: Dictionary<{[key: string]: boolean}>;
}>;

type Props = Readonly<{
  admission: AdmissionFromSearch;
}>;

const PccAdmittedActionsRenderer = ({
  isResideAdmin,
  admission,
  isOrgAdmin,
  isFacilityAdmin,
  facilityFlagsById,
}: Props & StateProps) => {
  const {facilityId} = admission;

  const {toggleModal: toggleDeleteModal} = useDashboardModalContext(
    ModalName.CANCEL,
  );
  const {toggleModal: toggleForceDeleteModal} = useDashboardModalContext(
    ModalName.FORCE_DELETE,
  );

  const isDisabled = isDeleteRestrictedForUser({
    facilityFlags: facilityFlagsById[facilityId],
    isOrgAdmin,
    isFacilityAdmin,
  });

  return (
    <AdmissionCardActionsMenu
      testId={getResidentTestId(admission, "pccAdmittedCardActions")}
    >
      {isResideAdmin ? (
        <>
          <DropdownMenuItem
            onClick={() => !isDisabled && toggleDeleteModal(admission)}
            testId={getResidentTestId(admission, "deletePccPreflight-delete")}
            disabled={isDisabled}
          >
            <Text color="deepOrange100">Delete</Text>
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => toggleForceDeleteModal(admission)}
            testId="force-delete-pcc-preflight"
          >
            <Text color="deepOrange100">Force Delete</Text>
          </DropdownMenuItem>
        </>
      ) : (
        <DropdownMenuItem
          onClick={() => toggleDeleteModal(admission)}
          testId={getResidentTestId(admission, "deletePccPreflight")}
          disabled={isDisabled}
        >
          <Text color="deepOrange100">Delete</Text>
        </DropdownMenuItem>
      )}
    </AdmissionCardActionsMenu>
  );
};

const mapStateToProps = (state: any): StateProps => ({
  isResideAdmin: select.adminSession.isResideAdmin(state),
  isOrgAdmin: select.adminSession.isOrgAdmin(state),
  isFacilityAdmin: select.adminSession.isFacilityAdmin(state),
  facilityFlagsById: select.adminSession.facilityFlagsById(state),
});

export const PccAdmittedActions = connect(mapStateToProps)(
  PccAdmittedActionsRenderer,
);
